module.exports = __webpack_public_path__ + "img/x_letter_r.796ce1b1.svg";